import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { trackPageView } from './utils/analytics';
import { usePageMeta } from './utils/usePageMeta';
import {
  Navbar, Hero, Areas, Socias, Resenas, EstadoCaso, Agendar, Finiquito,
  Servicios, FAQ, Trabaja, Oficinas, Footer, WhatsAppButton,
} from './components';
import PanelApp from './components/Panel/PanelApp';
import DerechoLaboral from './pages/DerechoLaboral/DerechoLaboral';
import DerechoFamilia from './pages/DerechoFamilia/DerechoFamilia';
import DerechoCivil from './pages/DerechoCivil/DerechoCivil';
import CalculadoraFiniquito from './pages/CalculadoraFiniquito/CalculadoraFiniquito';
import AsistenteLegal from './pages/AsistenteLegal/AsistenteLegal';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import './styles/global.css';

const Home: React.FC = () => {
  usePageMeta(
    'Souza & Villa Abogadas | Estudio Jurídico en Concepción',
    'Abogadas en Concepción. Primera consulta gratis y respuesta por WhatsApp el mismo día. Derecho Laboral, de Familia, Migratorio y Civil, en lenguaje claro.',
    '/',
  );
  return (
  <>
    <Navbar />
    <Hero />
    <Socias />
    <Resenas />
    <Areas />
    <Agendar />
    <Servicios />
    <Finiquito />
    <EstadoCaso />
    <FAQ />
    <Oficinas />
    <Trabaja />
    <Footer />
    <WhatsAppButton />
  </>
  );
};

// Envía un page_view de GA4 en cada cambio de ruta de la SPA.
const AnalyticsTracker: React.FC = () => {
  const location = useLocation();
  React.useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
};

// Al abrir una URL con ancla (ej. /#agendar, desde un anuncio o enlace externo),
// el navegador no salta a la sección porque el contenido de la SPA aún no está
// renderizado. Esto espera a que exista el elemento y hace scroll hasta él.
const ScrollToHash: React.FC = () => {
  const { hash } = useLocation();
  React.useEffect(() => {
    if (!hash) return;
    const id = decodeURIComponent(hash.slice(1));
    let tries = 0;
    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (tries++ < 10) {
        window.setTimeout(tryScroll, 150);
      }
    };
    const t = window.setTimeout(tryScroll, 100);
    return () => window.clearTimeout(t);
  }, [hash]);
  return null;
};

const App: React.FC = () => (
  <BrowserRouter>
    <AnalyticsTracker />
    <ScrollToHash />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/panel" element={<PanelApp />} />
      <Route path="/areas/derecho-laboral" element={<DerechoLaboral />} />
      <Route path="/areas/derecho-familia" element={<DerechoFamilia />} />
      <Route path="/areas/derecho-civil" element={<DerechoCivil />} />
      <Route path="/calculadora-finiquito" element={<CalculadoraFiniquito />} />
      <Route path="/asistente" element={<AsistenteLegal />} />
      <Route path="/reset-password" element={<ResetPassword />} />
    </Routes>
  </BrowserRouter>
);

export default App;
